import React, { useEffect, useState } from "react";
import Modal from "@src/components/modal/Modal";
import { LOGIN_PAGE_CONSTANTS } from "@src/constants/UiConstants";
import Login from "@src/pages/login/Login";
import { Typography } from "top-brains-ui";
import styles from "@src/components/login-modal/LoginModal.module.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearIntendedPath, setUserLogin } from "@src/app/globalSlice";
import { isElectronApp } from "@src/utils/envUtils";

interface LoginModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  modelType?: string;
}

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, modelType }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalSize, setModalSize] = useState({
    width: "480px",
    height: "640px",
    maxHeight: "620px",
  });
  const isElectron = isElectronApp();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setModalSize({ width: "85%", height: "420px", maxHeight: "420px" });
      } else if (window.innerWidth <= 768) {
        setModalSize({ width: "90%", height: "480px", maxHeight: "480px" });
      } else {
        setModalSize({ width: "480px", height: "640px", maxHeight: "620px" });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSignUpClick = () => {
    dispatch(setUserLogin(false));
    navigate("/signup");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (modelType === "login") {
          navigate("/");
        } else {
          dispatch(setUserLogin(false));
        }
        dispatch(clearIntendedPath());
      }}
      showPrimaryButton={false}
      showSecondaryButton={false}
      closeOnOutsideClick={false}
      showCloseButton={true}
      height={modalSize.height}
      maxHeight={modalSize.maxHeight}
      width={modalSize.width}
      variant="website"
      showFooter={false}
      body={
        <>
          <Login />
          {modelType !== "signup" ? (
            <div className={styles.defaultSection}>
              <div className={styles.createAccount}>
                <Typography
                  fontWeight="medium"
                  textAlign="center"
                  fontSize={16}
                  color={
                    isElectron
                      ? "var(--app-text-primary)"
                      : "var(--modal-body-color)"
                  }
                >
                  {LOGIN_PAGE_CONSTANTS.CREATE_ACCOUNT}
                  <span
                    onClick={handleSignUpClick}
                    className={`${styles.createAccountLink} ${
                      isElectron ? styles.electron : ""
                    }`}
                  >
                    {" "}
                    Signup
                  </span>
                </Typography>
              </div>
            </div>
          ) : null}

          {modelType === "signup" ? (
            <div className={styles.registerAccount}>
              <Typography
                fontWeight="medium"
                textAlign="center"
                fontSize={16}
                color={
                  isElectron
                    ? "var(--app-text-primary)"
                    : "var(--modal-body-color)"
                }
              >
                {LOGIN_PAGE_CONSTANTS.ACCOUNT_EXSISTING}
                <span
                  style={{
                    color: isElectron
                      ? "var(--app-primary)"
                      : "var(--login-text-color, #008C33)",
                    cursor: "pointer",
                  }}
                  onClick={() => dispatch(setUserLogin(true))}
                >
                  {" "}
                  Login
                </span>
              </Typography>
            </div>
          ) : null}

          <div className={styles.supportStyles}>
            {/* <Typography fontSize={16} color="#A8A8A8">
              Terms & Conditions
            </Typography>
            <Typography fontSize={16} color="#A8A8A8">
              Support
            </Typography>
            <Typography fontSize={16} color="#A8A8A8">
              Customer Care
            </Typography> */}
          </div>
        </>
      }
    />
  );
};

export default LoginModal;
